import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { SiLeetcode } from "react-icons/si";
import { about } from '../../portfolio'
import './About.css'
import Resume from '../Assets/Updated-Resume.pdf'


const About = () => {
  const { name, role, description, social } = about

  return (
    <div className='about center'>
      { name && (
        <h1>
          Hi, I am <span className='about__name'>{ name }.</span>
        </h1>
      ) }

      { role && <h2 className='about__role'>A { role }.</h2> }
      <p className='about__desc'>{ description && description }</p>

      <div className='about__contact center'>
        { Resume && (
          <a href={ Resume } download='Resume.pdf'>
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        ) }

        { social && (
          <>
            { social.github && (
              <a
                href={ social.github }
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon size={ 25 } />
              </a>
            ) }

            { social.linkedin && (
              <a
                href={ social.linkedin }
                aria-label='linkedin'
                className='link link--icon'
              >
                <LinkedInIcon size={ 25 } />
              </a>
            ) }
            { social.linkedin && (
              <a
                href={ social.leetcode }
                aria-label='leetcode'
                className='link link--icon'
              >
                <SiLeetcode size={ 25 } />
              </a>

            ) }
          </>
        ) }
      </div>
    </div>
  )
}

export default About
